import { linkStrategy, linkStrategyCTA } from '@/App.datalayer';
import { PrivacyConsentValues } from '@/context/PortalPrivacyConsent/PortalPrivacyConsent.interface';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';
import {
  getDataLayerPageLoadMetadata,
  getDatalayerPageViewMetadata,
  PageLoadMetadata,
} from '@/hooks/useDataLayerPageLoad';
import { getOr } from 'lodash/fp';
import TagManager from 'react-gtm-module';

const DATALAYER_CONSENT_POSITION = 'tracking_consent_popup';
const DATALAYER_CONSENT_TYPE = 'cta';
const PRIVACY_CONSENT_ACTION_ATTR = 'data-datalayer-action';

const emitPageViewEvent = (eventAction: string, pageLoadMetadata: Partial<PageLoadMetadata>) => {
  const pageViewMetadata = getDatalayerPageViewMetadata();

  if (eventAction !== 'accept') return;

  const dataLayer = {
    language: 'en',
    event: 'trackPageview-portalConsentAccepted',
    ...pageLoadMetadata,
    ...pageViewMetadata,
    portal_tracking_status: PrivacyConsentValues.CONSENT_ACCEPTED, // to override the portal_tracking_status from pageLoadMetadata
  };
  TagManager.dataLayer({ dataLayer });
};

export const onDataLayerConsentModalActionCTAClick = ({ target }: OnDatalayerProps) => {
  const eventAction = target.getAttribute(PRIVACY_CONSENT_ACTION_ATTR);
  if (!eventAction) return undefined;

  const pageLoadMetadata = getDataLayerPageLoadMetadata();

  const eventConfig = getOr({}, eventAction, {
    accept: {
      event: 'trackEvent-portalConsentAccepted',
      event_name: 'portal_tracking_consent_accepted',
      portal_tracking_status: PrivacyConsentValues.CONSENT_ACCEPTED,
    },
    decline: {
      event: 'trackEvent-portalConsentDecline',
      event_name: 'portal_tracking_consent_decline',
      portal_tracking_status: PrivacyConsentValues.CONSENT_REJECTED,
    },
  });

  emitPageViewEvent(eventAction, pageLoadMetadata);

  return {
    ...eventConfig,
    position: DATALAYER_CONSENT_POSITION,
    type: DATALAYER_CONSENT_TYPE,
    ...pageLoadMetadata,
    // Overrides session metadata original portal_tracking_status
    portal_tracking_status: eventConfig.portal_tracking_status,
  };
};

export const onDatalayerConsentModalLinkClick = ({ target }: OnDatalayerProps) => {
  if (!target) return undefined;
  return linkStrategy({ target, position: DATALAYER_CONSENT_POSITION });
};

export const onDatalayerConsentModalCTAClick = ({ target }: OnDatalayerProps) => {
  if (!target) return undefined;
  return linkStrategyCTA({ target, position: DATALAYER_CONSENT_POSITION });
};
